<label class="control" [class.disabled]="disabled()">
    <span class="box">
        <input
            [class.checked]="value() || indeterminate()"
            type="checkbox"
            [name]="name()"
            [disabled]="disabled()"
            [required]="required()"
            [checked]="value()"
            [indeterminate]="indeterminate()"
            (change)="toggle()"
        />
        <mat-icon
            class="checked"
            [class.indeterminate]="!value() && indeterminate()"
            [svgIcon]="value() ? 'checkbox-check' : 'checkbox-indeterminate'"
            [hidden]="!value() && !indeterminate()"
            aria-hidden="true"
        ></mat-icon>
    </span>
    <span class="text"><ng-content></ng-content></span>
</label>
